<template>
	<!-- 留言 -->
	<div class="tips">
		<ul v-if="list.length > 0">
			<li v-for="(item, index) in list" :key="index">
				<div class="img">
					<img :src="$imgUrl + item.photo" alt="" v-if="item.avatar != ''" />
					<img src="../../assets/image/avatar.png" alt="" v-else />
				</div>
				<div class="info">
					<div class="username">{{ item.name }}</div>
					<div class="message">
						{{ item.content }}
						<span v-if="true">【未读{{item.weidu}}条】</span>
					</div>
				</div>
				<div class="button"><el-button type="warning" plain size="mini" @click="openCustomerServer(item)">留言</el-button></div>
			</li>
		</ul>
		<ul v-else>
			<el-empty description="当前暂无消息"></el-empty>
		</ul>
		<!-- <div class="page-pager">
			<el-pagination
				background
				layout="total, prev, pager, next"
				:total="total"
				:pager-count="11"
				:page-size="pagesize"
				:current-page="currentPage"
				:current-change="pageChange"
			></el-pagination>
		</div> -->
	</div>
</template>

<script>
import {
	contactIndexListApi, readtypechange2
} from '../../http/api/user.js'
export default {
	name: 'tips',
	data() {
		return {
			total: 100,
			pagesize: 12,
			currentPage: 1,
			list: []
		};
	},
	created() {
		this.getList()
	},
	methods: {
		getList(){
			contactIndexListApi({
				type: 2
			}).then(res => {
				this.list = res
			})
		},
		openCustomerServer(item){
			if(item.weidu>0){
				readtypechange2({id:item.id}).then(res=>{
					// console.log(res)

				})
			}

			this.$router.push({
				path: '/factoryUser/customerServer',
				query: {
					sessionId: item.id
				}
			})
		}
	},

};
</script>

<style lang="less" scoped="scoped">
.tips {
	width: 100%;
	min-height: 500px;
	background: @vue-bg-color;
	ul {
		width: 100%;
		min-height: 450px;
		li {
			width: 100%;
			height: 100px;
			display: flex;
			align-items: center;
			border-bottom: 1px solid @vue-border-color;
			padding: 0px @vue-spacing-row-lg;
			box-sizing: border-box;
			.img {
				width: 60px;
				height: 60px;
				border-radius: @vue-border-radius-lg;
				overflow: hidden;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.info {
				width: calc(100% - 200px);
				padding-left: @vue-spacing-row-base;
				box-sizing: border-box;
				.username {
					width: 100%;
					height: 30px;
					font-size: @vue-font-size-sm;
					font-weight: bold;
				}
				.message {
					width: 100%;
					line-height: 25px;
					font-size: @vue-font-size-sm - 2;
					span {
						color: @vue-text-color-red;
					}
				}
			}
			.button {
				width: 140px;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: flex-end;
			}
		}
	}
	.page-pager{
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
	}
}
</style>
